import {to_isAddressable}      from "@Common/logic/template-options/template-options-is-addressable";
import {cleanItem, itemEditor} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {AddressableShippingQuantityLogic} from "./addressable-shipping-quantity-logic";
import {EnableAddressableShippingLogic}   from "./enable-addressable-shipping-logic";

export const addressableShippingModules = ({templateOptions, item}) => [

    {
        name: "addressableShippingQuantity1",
        load: ({}, next) => AddressableShippingQuantityLogic({item, next}),
        expo: [cleanItem],
    },
    {
        name: "addressableShippingQuantity2",
        load: ({addressableShippingQuantity1, enableAddressableShippingLogic2}, next) => enableAddressableShippingLogic2?.state.value ? (
            addressableShippingQuantity1.next({next})
        ) : (
            next(null)
        ),
        requires: ["addressableShippingQuantity1", "enableAddressableShippingLogic2"],
        expo: [itemEditor], // No need exporting UI, as this is accessed directly in top-control module
    },

    {
        name: "enableAddressableShippingLogic1",
        load: ({}, next) => EnableAddressableShippingLogic({item, next}),
        expo: [cleanItem],
    },
    {
        name: "enableAddressableShippingLogic2",
        load: ({enableAddressableShippingLogic1, method}, next) => (method === "shipping" || method === "pickup") && to_isAddressable(templateOptions) ? (
            enableAddressableShippingLogic1.next({next})
        ) : (
            next(null)
        ),
        requires: ["enableAddressableShippingLogic1", "method"],
        expo: [itemEditor], // No need exporting UI, as this is accessed directly in top-control module
    },

];

